export default {
  'gtc-table': {
    total: 'Total {total} items',
    perPage: '{value} items/page',
    itemsPerPage: 'items/page',
    jumpTo: 'Jump to',
    jumpToConfirm: 'Go',
    page: 'page',
  },
  'gtc-range-picker': {
    today: 'Today',
    week: 'This week',
    lastWeek: 'Last week',
    month: 'This month',
    lastMonth: 'Last month',
  },
  'gtc-drawer': {
    cancelText: 'Cancel',
    okText: 'Confirm',
    closeAriaLabel: 'Close drawer',
  },
}
